import {VatRateRepo} from "../api/vat-rate.repo";
import {inject, Injectable} from "@angular/core";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {VatRateDto} from "../dto/vat-rate.dto";
import {DuckDbHelper} from "./duckdb.helper";
import {isDefined, notDefined} from "../../libs/utils/epic.utils";
import {VatRate} from "../../libs/enum/vat-rate.enum";
import {LoggingService} from "../../services/logger/logging.service";

@Injectable({providedIn: 'root'})
export class VatRateDuckDb extends VatRateRepo {

  private readonly duck: DuckDbHelper = inject(DuckDbHelper);
  private readonly log: LoggingService = inject(LoggingService);

  private vats: VatRateDto[] = [];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readCurrent(_org: OrgDto): Observable<WrapperDto<VatRateDto>> {
    const vats: VatRateDto[] = this.vats.filter((v) => v.state === 'CURRENT');
    return DuckDbHelper.datasObs('VatRateDto', vats);
  }

  public override readByDate(_org: OrgDto, date: Date): Observable<WrapperDto<VatRateDto>> {
    const vat = this.vats
      .find((v) => (isDefined(v.validFrom) && v.validFrom <= date) && (notDefined(v.validUntil) || v.validUntil >= date));
    if (isDefined(vat)) {
      return DuckDbHelper.dataObs('VatRateDto', vat);
    }
    this.log.error('VatRate not found for date "{}"', [date]);
    return DuckDbHelper.dataObs('VatRateDto', new VatRateDto());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override readAll(_org: OrgDto): Observable<WrapperDto<VatRateDto>> {
    return DuckDbHelper.datasObs('VatRateDto', this.vats);
  }

  // Init by OrgDuckDb.readById
  public loadVats(): void {
    const sql = `
      SELECT v.id          AS id,
             v.vat_rate    AS vatRate,
             v.value,
             v.valid_from  AS validFrom,
             v.valid_until AS validUntil
      FROM vat_rate v`;
    this.duck.sql(sql).subscribe((res: any) => {
      if (DuckDbHelper.hasRes(res)) {
        this.vats = res.map((v: any) => {
          v.state = this.getState(v);
          v.oldPart = this.isOldPart(v);
          return new VatRateDto(v);
        });
      }
    });
  }

  private getState(res: any): string {
    const now = new Date();
    const validFrom = new Date(res.validFrom);
    const validUntil = isDefined(res.validUntil) ? new Date(res.validUntil) : undefined;
    if (validFrom < now && (notDefined(validUntil) || validUntil > now)) {
      return 'CURRENT';
    } else if (validFrom > now) {
      return 'FUTURE';
    }
    return 'EXPIRED';
  }

  private isOldPart(res: any): boolean {
    if (isDefined(res.vatRate)) {
      return res.vatRate === VatRate.OLD_PART_STANDARD || res.vatRate === VatRate.OLD_PART_CREDIT;
    }
    return false;
  }
}
